export const convertStockData = (data) => {
    const stockGraph = Object.entries(data).map(([date, values]) => ({
        x: new Date(date),
        y: [values["Open"]?.toFixed(2), values["High"]?.toFixed(2), values["Low"]?.toFixed(2), values["Close"]?.toFixed(2) ]
    }));
    return stockGraph;
};

export function vh(percent) {
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    return (percent * h) / 100;
}